<template>
  <div>
    <div class="sayfahead tek">
      <Yukleniyor :data="lo"></Yukleniyor>
      <h1 v-if="Fatura">{{ Fatura.BinaAdi }} - {{ Fatura.aciklama }}</h1>
      <el-button-group class="float-right YeniBtn">
        <el-button type="primary" v-if="Hesap_id==6" size="small" @click="HBDuzenle()" icon="el-icon-edit">HB. Düzenle
        </el-button> <!--  && !Fatura.eFaturaLink -->
        <el-button type="warning" size="small" @click="SayfaYukle()">Yenile</el-button>
        <el-button v-if="Hesap_id==6 && !Fatura.eFaturaLink" type="primary" size="small"
                   @click="FaturaGonder(Fatura.id,Fatura.OnayBilgi.OkumaUcreti)">E-Fatura Kes <small>F:
          {{ Fatura.OnayBilgi.OkumaUcreti }}</small> <small>/ M: {{ Fatura.OnayBilgi.OkumaTahsil }}</small>
        </el-button>
        <el-button v-if="(Hesap_id==6 || Hesap_id==9) && Fatura.AVT && Fatura.AVT!='v10'" type="info" size="small"
                   @click="Borclandirma()">Aidatım'a Gönder
        </el-button>

        <el-button type="danger" size="small" @click="DonemSil()" icon="el-icon-warning">Dönemi İptal Et</el-button>
        <el-button type="warning" size="small" @click="Excel" icon="el-icon-download">Excel İndir</el-button>

        <el-button type="success" size="small" @click="MailGonder" v-if="Fatura.Tur!='3'" icon="el-icon-s-promotion">
          Mail Gönder
        </el-button>

        <el-popover
          placement="top-start"
          width="200">
          <el-button slot="reference" type="info" size="small" icon="el-icon-printer">
            Yazdır
          </el-button>
          <div style="padding: 10px">
            <p style="text-align: center;border-bottom: 1px solid #ccc;">Yazdırma İşlemleri</p>
            <el-button class="btn-block" size="small" @click="Yazdir('MeskenDokum')">Lazer Belge Yazdır</el-button>
            <div class="clearfix"></div>
            <el-button class="btn-block" size="small" @click="Yazdir('a5')">A5 Belge Yazdır</el-button>
            <div class="clearfix"></div>
            <el-button class="btn-block" size="small" @click="Yazdir('Aski')">Askı Dökümü Yazdır</el-button>
            <hr>
            <el-button class="btn-block btn-success" size="small" @click="Yazdirildi()">Dökümlerden Kaldır</el-button>
          </div>
        </el-popover>
      </el-button-group>
    </div>
    <div class="icerik">
      <el-alert
        v-if="Hesap_id==6 && !Fatura.eFaturaLink"
        title="E-Fatura Kesilmemiş"
        type="error"
        :closable="false"
        description="Çıktı almadan öcne E-Fatura Kes butonunu ile faturayı oluşturunuz">
      </el-alert>
      <div v-if="Fatura.Tur!='3'">

        <SayacGrupAski :Hesap_id="Hesap_id" v-if="YazdirTur=='Aski' && GrupAski" :Fatura="Fatura" :AltToplam="AltToplam"
                       :GrupDokum="Grup" :Logo="Logo"></SayacGrupAski>

        <SayacAskiListesi :Hesap_id="Hesap_id" v-if="YazdirTur=='Aski' && !GrupAski" :Fatura="Fatura"
                          :AltToplam="AltToplam"
                          :FaturaDokum="FaturaDokum" :Logo="Logo"></SayacAskiListesi>
        <Sayaca5 :Hesap_id="Hesap_id" v-if="YazdirTur=='a5'" :Fatura="Fatura" :Logo="Logo" :AltToplam="AltToplam"
                 :FaturaDokum="FaturaDokum"></Sayaca5>
        <SayacLazer :Hesap_id="Hesap_id" v-if="YazdirTur=='MeskenDokum'" :Logo="Logo" :Fatura="Fatura"
                    :AltToplam="AltToplam"
                    :FaturaDokum="FaturaDokum"></SayacLazer>
        <BinaHesaplamaDokumu :Hesap_id="Hesap_id" v-if="YazdirTur=='Hesaplama'" :Logo="Logo" :Fatura="Fatura"
                             :AltToplam="AltToplam"
                             :FaturaDokum="FaturaDokum"></BinaHesaplamaDokumu>

      </div>
      <div v-if="Fatura.Tur=='3'">
        <ElektrikLazer :Hesap_id="Hesap_id" v-if="YazdirTur=='MeskenDokum'" :Logo="Logo" :Fatura="Fatura"
                       :AltToplam="AltToplam"
                       :FaturaDokum="FaturaDokum"></ElektrikLazer>
        <ElektrikAski :Hesap_id="Hesap_id" v-if="YazdirTur=='Aski' && !GrupAski" :Fatura="Fatura"
                      :AltToplam="AltToplam"
                      :FaturaDokum="FaturaDokum" :Logo="Logo"></ElektrikAski>


      </div>

    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import SayacAskiListesi from "../../../components/Pack/Esayac/SayacAskiListesi";
import Yukleniyor from "../../../components/Doc/Yukleniyor";
import {router} from "../../../router";
import Sayaca5 from "../../../components/Pack/Esayac/Sayaca5";
import SayacLazer from "../../../components/Pack/Esayac/SayacLazer";
import BinaHesaplamaDokumu from "../../../components/Pack/Esayac/BinaHesaplamaDokumu";
import SayacGrupAski from "../../../components/Pack/Esayac/SayacGrupAski";
import ElektrikLazer from "../../../components/Pack/Esayac/ElektrikLazer";
import ElektrikAski from "../../../components/Pack/Esayac/ElektrikAski";

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
  name: XLSX.utils.encode_col(i),
  key: i
}));
export default {
  components: {
    ElektrikAski,
    ElektrikLazer,
    SayacGrupAski,
    BinaHesaplamaDokumu,
    SayacLazer,
    Sayaca5,
    Yukleniyor,
    SayacAskiListesi
  },
  props: ['Fatura_id'],
  data() {
    return {
      lo: false,
      Fatura: null,
      Logo: null,
      MailAyar: null,
      FaturaDokum: null,
      MailAdres: null,
      GrupAski: false,
      Grup: null,
      AltToplam: null,
      ExcelData: null,
      MailDurum: null,
      Hesap_id: null,
      YazdirTur: 'MeskenDokum'
    }
  },
  methods: {

    FaturaGonder(id, Tutar) {
      this.$prompt('E-Fatura api sistemine gönderilerek muhasebeleştirilecektir onaylıyormusunuz ? Tutarı düzenleyebilirsiniz.', 'E-Fatura Onayı', {
        confirmButtonText: 'Onayla',
        cancelButtonText: 'Vazgeç',
        inputValue: Tutar,
        inputPlaceholder: 'Fatura Tutarı'
      }).then(({value}) => {
        this.EFatura(id, value)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'İptal Edildi'
        });
      });
    },
    HBDuzenle() {
      this.$prompt('Hizmet bedelleri düzenlenip tekrar hesaplanacaktır. Onaylıyormusunuz?', 'Hizmet Bedeli Düzenle', {
        confirmButtonText: 'Onayla ve Yeniden Hesapla',
        cancelButtonText: 'Vazgeç',
        inputValue: this.Fatura.Okuma,
        inputPlaceholder: 'Hizmet Bedeli'
      }).then(({value}) => {
        if (value)
          this.HBPost(value)
        else
          this.$message.error("Hizmet bedeli boş");
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'İptal Edildi'
        });
      });
    },
    HBPost(Tutar) {
      if (this.Fatura.Okuma == Tutar) {
        this.$message.error("Hizmet bedelinde değişiklik yok");

      } else {
        this.$store.dispatch("Post", {Tutar: Tutar, path: '_enerji/donem/hbpost/' + this.Fatura.id})
          .then(response => {
            this.lo = false;
            if (response.Durum == "OK") {
              this.$message.success(response.Mesaj);
              this.SayfaYukle();
            } else {
              this.$message.error(response.Mesaj);
            }
          })
        this.lo = true;
      }

    },
    EFatura(id, Tutar) {
      this.lo = true;
      this.$store.dispatch("Post", {Tutar: Tutar, path: '_a/efatura/' + id})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.$message.success(response.Mesaj);
            this.SayfaYukle();
          } else {
            this.$message.error(response.Mesaj);
          }
        })
    },
    Borclandirma() {
      this.$confirm("Borçlandırma gönderilecektir. <br> İşlemi onaylıyormusunuz?", "Veri gönderim onayı", {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.BorclandirmaOnay()
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    BorclandirmaOnay() {
      this.lo = true;
      this.$store.dispatch("Get", {path: '_enerji/dokum/borclandir/' + this.Fatura_id})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.$message.success("Aidatım'a Gönderildi");
          } else {
            this.$message.error(response.Mesaj);
          }
        });
    },
    Yazdirildi() {
      this.lo = true;
      this.$store.dispatch("Get", {path: '_enerji/dokum/yazdirildi/' + this.Fatura_id})
        .then(response => {
          if (response.Durum === 'OK') {
            this.$message.success(response.Mesaj);
            this.Fatura.Yazdir = '2';
          } else {
            this.$message.error(response.Mesaj);
          }
        });
    },
    Yazdir(id) {
      this.lo = true;
      this.YazdirTur = id
      // if (id == 'Aski') {
      //   $(".Aski").attr("style", "display:block");
      //   $(".MeskenDokum").attr("style", "display:none");
      //   $(".a5").attr("style", "display:none");
      // } else if (id == 'MeskenDokum') {
      //   $(".MeskenDokum").attr("style", "display:block");
      //   $(".Aski").attr("style", "display:none");
      //   $(".a5").attr("style", "display:none");
      // } else if (id == 'a5') {
      //   $(".a5").attr("style", "display:block");
      //   $(".MeskenDokum").attr("style", "display:none");
      //   $(".Aski").attr("style", "display:none");
      // }

      setTimeout(() => {
        this.lo = false;
        window.print();
      }, 2000);
    },
    Excel(evt) {

      const ws = XLSX.utils.json_to_sheet(this.ExcelData);
      const wb = XLSX.utils.book_new();
      ws['!cols'] = [
        {wch: 15},
        {wch: 15},
        {wch: 30},
        {wch: 30},
        {wch: 25},
        {wch: 20},
        {wch: 15},
        {wch: 40},
        {wch: 20},
        {wch: 12},
      ];

      wb.Props = {
        Title: this.Fatura.BinaAdi + " " + this.Fatura.aciklama,
        Author: "Aidatim APP",
        Manager: "Aidatim APP",
        Company: "Aidatim",
        Category: "Finans",
        Keywords: "Aidatim",
        Comments: this.Fatura.BinaAdi + " " + this.Fatura.aciklama,
      };
      XLSX.utils.book_append_sheet(wb, ws, this.Fatura.BinaAdi);
      XLSX.writeFile(wb, this.Fatura.BinaAdi + " " + this.Fatura.aciklama + ".xlsx");
    },
    MailGonder() {
      this.$prompt('Gönderilecek mail adreslerini yazınız.<hr>' + this.MailDurum, 'Mail Gönder', {
        confirmButtonText: 'Mail Gönder',
        cancelButtonText: 'Vazgeç',
        inputValue: this.MailAdres,
        inputPlaceholder: 'Mail Adresleri',
        dangerouslyUseHTMLString: true,
      }).then(({value}) => {

        this.MailYolla(value);


      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Mail İptal Edildi'
        });
      });
    },
    MailYolla(Adresler) {
      if (Adresler) {
        this.lo = true;
        this.$store.dispatch("Post", {
          Mail: Adresler,
          MailAyar: this.MailAyar,
          Logo: this.Logo,
          Donem_id: this.Fatura_id,
          Url: 'https://sendmail.yapifenenerji.net/pdf.php',
          path: ''
        })
          .then(response => {
            this.lo = false
            if (response == '1') {
              this.$message.success('Mail gönderildi')
            } else {
              this.$message.error('Mail gönderilemedi')
            }
          });
      } else {
        this.$message.error('Mail adresleri boş')
      }
    },
    DonemSil() {
      this.$confirm("Dönem silinip okuma önceki endeksler geri yüklenecektir. <br> İşlemi onaylıyormusunuz?", "Silme Onayı", {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.DonemSilOnay()
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    DonemSilOnay() {
      this.lo = true;
      this.$store.dispatch("Delete", {path: '_enerji/dokum/' + this.Fatura_id})
        .then(response => {
          this.lo = false
          if (response.Durum === 'OK') {
            this.$message.success("Dönem silindi");
            router.push("/dokum");
          } else {
            this.$message.error(response.Mesaj);
          }
        });
    },
    SayfaYukle() {
      this.Hesap_id = JSON.parse(localStorage.getItem('_aiHesap'))['id'];
      this.lo = true;
      this.$store.dispatch("Get", {path: '_enerji/dokum/fatura/' + this.Fatura_id})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Fatura = response.Fatura;
            this.FaturaDokum = response.FaturaDokum;
            this.AltToplam = response.AltToplam;
            this.ExcelData = response.ExcelData;
            this.MailAdres = response.MailAdres;
            this.MailDurum = response.MailDurum;
            this.Logo = response.Logo;
            this.Grup = response.Grup;
            this.GrupAski = response.Grup ? true : false;
            this.MailAyar = response.MailAyar;
            this.lo = false
            if (this.MailAdres) {
              this.$notify({
                title: 'Mail adresi var',
                message: 'Mail göndermeyi unutmayın!',
                position: 'bottom-right',
                type: 'warning'
              });
            }


          } else {
            this.$message.error(response.Mesaj);
          }
        });

    },

  },
  created() {
    this.SayfaYukle()
  }
}
</script>

<style scoped>
.yazdirtable {
  display: block;
}

.st0 {
  fill: #000000;
}

.st1 {
  fill: #000000;
}

.st2 {
  fill: #FFFFFF;
}

.MeskenDokum svg {
  display: block;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/_Sayac/Dokum/Detay.vue